var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heatmap/light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heatmap/light",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heatmap-copy",
    fill: "#F5F8FA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,11 C0.9,11 0,11.9 0,13 C0,14.1 0.9,15 2,15 C3.1,15 4,14.1 4,13 C4,11.9 3.1,11 2,11 Z M13,4 C14.1,4 15,3.1 15,2 C15,0.9 14.1,0 13,0 C11.9,0 11,0.9 11,2 C11,3.1 11.9,4 13,4 Z M16,8.5 C16,7.12 14.88,6 13.5,6 C12.52,6 11.68,6.57 11.27,7.39 C10.67,6.61 9.76,6.09 8.71,6.03 C8.89,5.54 9,5.04 9,4.5 C9,2.01 6.99,0 4.5,0 C2.01,0 0,2.01 0,4.5 C0,6.99 2.01,9 4.5,9 C4.69,9 4.87,8.97 5.06,8.94 C5.03,9.13 5,9.31 5,9.5 C5,11.43 6.57,13 8.5,13 C10.13,13 11.48,11.89 11.87,10.38 C12.31,10.76 12.87,11 13.5,11 C14.88,11 16,9.88 16,8.5 Z M14.5,13 C13.67,13 13,13.67 13,14.5 C13,15.33 13.67,16 14.5,16 C15.33,16 16,15.33 16,14.5 C16,13.67 15.33,13 14.5,13 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/defaultLogo.2a4fc5b547137fe6f23686a45e4e28e6.svg";
export { ForwardRef as ReactComponent };